<template>
	<div :class="{'has-error': mensagemErro}">
		<slot name="label">
			<label>
				<span v-if="obrigatorio" class="no-print">*</span> {{ label }}:
			</label>
		</slot>
		<date-picker
			class="datepicker-input form-control-datepicker"
			type="datetime"
			value-type="YYYY-MM-DD HH:mm"
			format="DD/MM/YYYY HH:mm"
			:value="value"
			@input="$emit('input', $event)"
			input-class="class-input"
			:disabled-date="disabledDate"
			:disabled-time="disabledTime"
		></date-picker>
		<p class="help-block" v-show="mensagemErro">{{ mensagemErro }}</p>
	</div>
</template>

<script>
export default {
	props: {
		label: {
			type: String
		},

		value: {
			type: String,
			required: false,
			default: ''
		},

		mensagemErro: {
			type: String,
			required: false,
			default: ''
		},

		obrigatorio: {
			type: Boolean,
			required: false,
			default: false
		},

		maxDate: {
			type: Object
		},

		minDate: {
			type: Object
		}
	},
	methods: {
		disabledDate(date) {
			let passou = false
			if (this.maxDate) {
				passou =
					moment(date).format('YYYY-MM-DD') >
					moment(this.maxDate).format('YYYY-MM-DD')
			}
			if (this.minDate && !passou) {
				passou =
					moment(date).format('YYYY-MM-DD') <
					moment(this.minDate).format('YYYY-MM-DD')
			}
			return passou
		},
		disabledTime(date) {
			let passou = false
			if (this.maxDate) {
				passou =
					moment(date).format('YYYY-MM-DD HH:mm') >
					moment(this.maxDate).format('YYYY-MM-DD HH:mm')
			}
			if (this.minDate && !passou) {
				passou =
					moment(date).format('YYYY-MM-DD HH:mm') <
					moment(this.minDate).format('YYYY-MM-DD HH:mm')
			}
			return passou
		}
	}
}
</script>

<style scoped>
.class-input {
	font-size: 11px !important;
}
</style>